export default __webpack_public_path__ + "assets/images/Dashboard-182e1178890f5849ae3e4c7ac598a4db.svg";